import { render } from "./AddValidatingUsers.vue?vue&type=template&id=3510ac9e&scoped=true"
import script from "./AddValidatingUsers.vue?vue&type=script&lang=js"
export * from "./AddValidatingUsers.vue?vue&type=script&lang=js"

import "./AddValidatingUsers.vue?vue&type=style&index=0&id=3510ac9e&scoped=true&lang=css"

import exportComponent from "/home/u624473994/domains/backoffice.quickpay.pe/quickshop-admin-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3510ac9e"]])

export default __exports__